import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const EmployersRatingScaleMediumKindDefault = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.9485 6.1363L12.9511 6.13446C13.2936 5.88828 13.7164 5.78902 14.1288 5.85643C14.5409 5.92379 14.9126 6.1527 15.1628 6.49668C15.671 7.20542 15.5094 8.19333 14.7998 8.70486C14.4574 8.95094 14.0347 9.05014 13.6224 8.98274C13.2101 8.91537 12.8384 8.68635 12.5882 8.34222C12.4676 8.17458 12.3808 7.98384 12.3333 7.78106C12.2858 7.57794 12.2787 7.36715 12.3124 7.16113C12.3462 6.95512 12.4201 6.75837 12.5295 6.58237C12.6389 6.4064 12.7814 6.25485 12.9485 6.1363Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={1.5}
            />
            <rect
                x={12.0029}
                y={11.5348}
                width={3.74564}
                height={5.87929}
                rx={0.75}
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={1.5}
            />
            <path
                d="M8.25146 14.6177C8.25146 14.2035 8.58725 13.8677 9.00146 13.8677H11.2471C11.6613 13.8677 11.9971 14.2035 11.9971 14.6177V17.4143H9.00146C8.58725 17.4143 8.25146 17.0785 8.25146 16.6643V14.6177Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={1.5}
            />
        </svg>
    ),
    'Employers'
);
export default EmployersRatingScaleMediumKindDefault;
